var map = {
	"./account-credit-card-disabled.svg": 4605,
	"./account-credit-card.svg": 4455,
	"./admin-icon-disabled.svg": 7158,
	"./admin-icon.svg": 878,
	"./ambulance.svg": 9065,
	"./ant-design_setting-filled.svg": 8927,
	"./aset_tak_berwujud.svg": 5812,
	"./chevron-right.svg": 356,
	"./clarity_date-line.svg": 3912,
	"./contact.svg": 3269,
	"./derek.svg": 2227,
	"./gangguan_aset.svg": 3067,
	"./gedung_bangunan.svg": 5083,
	"./ion_chevron-up-outline.svg": 7604,
	"./jalan_irigasi_perbaikan.svg": 4864,
	"./kecelakaan.svg": 1419,
	"./kecpt_rata2.svg": 43,
	"./kejadian_khusus.svg": 2977,
	"./layanan-aset-disabled.svg": 8637,
	"./layanan-aset.svg": 4261,
	"./logo.png": 971,
	"./material-symbols_folder.svg": 735,
	"./material-symbols_list-alt.svg": 4401,
	"./mdi-layanan-aset.svg": 5230,
	"./mdi_location.svg": 202,
	"./mesin_peralatan.svg": 8902,
	"./patroli.svg": 9199,
	"./ph_x-bold.svg": 3014,
	"./polisi.svg": 6356,
	"./rescue.svg": 5119,
	"./tanah.svg": 4481,
	"./traffic-light-disabled.svg": 8391,
	"./traffic-light.svg": 6129,
	"./wrench-clock-disabled.svg": 6576,
	"./wrench-clock.svg": 9271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;